const PERSONA_FIELDS = `
    id
    name
    description
    actionCodes {
      actionCode
      weight
    }
    testDefinitionIds
    lifecycle {
      wakeCadenceHours
      expectedLifespanDays
      cancellationLikelihoodPercent
    }
    createdByUsername
    updatedByUsername
    created
    updated
`;

export const createPersona = `
    mutation createPersona($input: CreatePersonaInput!) {
        createPersona(input: $input) {
            ${PERSONA_FIELDS}
    }
}`;

export const updatePersona = `
    mutation updatePersona($input: UpdatePersonaInput!) {
        updatePersona(input: $input) {
            ${PERSONA_FIELDS}
    }
}`;

// deletePersona returns a bare `ID`, not an object — no sub-selection.
export const deletePersona = `
    mutation deletePersona($input: DeletePersonaInput!) {
        deletePersona(input: $input)
}`;
